export default "__VITE_ASSET__DgKvjJFn__"